import { useHistory } from "react-router-dom";
import React, { useState } from "react";
import { ExternalAccountType, LanguageNameSpaces } from "@shared/types";
import useConnectTelegram from "features/onboarding/methodSettings/signalsGroup/connectExternalAccount/useConnectTelegram";
import ConnectExternalAccountTopSection from "features/onboarding/methodSettings/signalsGroup/connectExternalAccount/ConnectExternalAccountTopSection";
import EmptyView from "common/Empty/EmptyView";
import {
  EMPTY_GROUPS_DESCRIPTION,
  EMPTY_GROUPS_TITLE,
} from "@shared/common/constants";
import { MARKETPLACE_PATH } from "common/constants";
import ConnectExternalAccountModal from "features/onboarding/methodSettings/signalsGroup/connectExternalAccount/ConnectExternalAccountModal";
import { sharedLib } from "@shared/services/shared.service";
import { EmptyStatesType } from "common/Icons/types.ts";
import { useBottomNavigator } from "utils/hooks/misc.tsx";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { useSelectUser } from "@shared/utils/hooks/misc.ts";

interface GroupPageEmptyStateProps {
  noExternalAccountConnected?: boolean;
  noGroupsFound?: boolean;
  searchValue?: string;
}

const GroupPageEmptyState = ({
  noExternalAccountConnected,
  noGroupsFound,
  searchValue,
}: GroupPageEmptyStateProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.SIGNALS);
  const history = useHistory();
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();
  const user = useSelectUser();

  const [getGroupsData] =
    sharedLib.sharedApi.settings.useLazyGetGroupsDataQuery();

  const [externalAccountType, setExternalAccountType] = useState<
    ExternalAccountType | undefined
  >();
  const [externalAccountModalVisible, setExternalAccountModalVisible] =
    useState(false);

  const { queryCode, queryUuid } = useConnectTelegram(
    externalAccountType,
    setExternalAccountType,
    setExternalAccountModalVisible
  );

  const closeModal = () => {
    setExternalAccountType(undefined);
    setExternalAccountModalVisible(false);
  };

  const onSuccess = () => {
    getGroupsData();
  };

  const getGroupsPageEmptyState = () => {
    if (noExternalAccountConnected && !user?.isWhopExperience()) {
      return (
        <ConnectExternalAccountTopSection
          setAccountType={setExternalAccountType}
          style={{ padding: 16, maxWidth: 480 }}
          showLink={false}
        />
      );
    } else if (noGroupsFound) {
      return (
        <EmptyView
          iconKey={EmptyStatesType.Marketplace}
          iconWidth={isBottomNavigator ? 100 : 140}
          title={t(EMPTY_GROUPS_TITLE)}
          description={t(EMPTY_GROUPS_DESCRIPTION)}
          buttonText={t("empty_states.find_a_group")}
          buttonOnClick={() => history.push(MARKETPLACE_PATH)}
          isSearch={!!searchValue?.length}
          titleStyle={{ maxWidth: 350 }}
        />
      );
    }
  };

  return (
    <>
      {getGroupsPageEmptyState()}
      <ConnectExternalAccountModal
        visible={externalAccountModalVisible}
        externalAccountType={externalAccountType}
        onCancel={closeModal}
        onSuccess={onSuccess}
        uuid={queryUuid}
        code={queryCode}
      />
    </>
  );
};

export default GroupPageEmptyState;
